import { render, staticRenderFns } from "./IconBreadcrumb.vue?vue&type=template&id=c81a3b6e&"
import script from "./IconBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./IconBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c81a3b6e')) {
      api.createRecord('c81a3b6e', component.options)
    } else {
      api.reload('c81a3b6e', component.options)
    }
    module.hot.accept("./IconBreadcrumb.vue?vue&type=template&id=c81a3b6e&", function () {
      api.rerender('c81a3b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconBreadcrumb.vue"
export default component.exports